// extracted by mini-css-extract-plugin
export default {"image":"HY-z","loaded":"IY-z"};